// src/pages/PagoFallido.js
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PagoFallido = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/krums');
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="pago-fallido-container">
      <div className="pago-fallido-card">
        <div className="fallido-icon">❌</div>
        <h1>Pago no completado</h1>
        <p>Hubo un problema con tu pago. Por favor intenta de nuevo.</p>
        <button onClick={() => navigate('/krums')} className="btn-continuar">
          Volver a la tienda
        </button>
      </div>
    </div>
  );
};

export default PagoFallido;